import { ComposerModuleName } from '../@types'

export const SupportedAudioFormats = ['audio/mpeg', 'audio/ogg', 'audio/wav']
export const SupportedVideoFormats = ['video/mp4']
export const SupportedMediaFormats = [
  ...SupportedAudioFormats,
  ...SupportedVideoFormats,
]

export const EMBED_INPUT_CLASS = `${ComposerModuleName.Embed}-input`

export const FILE_SIZE_LIMIT = 52428800 // 50 MB in bytes
